import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { bonusDetails, guides } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';

/** Everything in the kit: the 6 core volumes plus the 5 extra bonuses. */
export function KitContentsSection() {
  return <section aria-labelledby="kit-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-121" data-mp="1xdfta1e2y8y6">
      <div className="mx-auto max-w-6xl" data-id="element-122" data-mp="1sgpbn9mmn5an">
        <SectionHeading id="kit-heading" eyebrow="Included With Your Purchase" title={<>
              6 Core Volumes + 5 Extra Bonuses. <Accent data-id="element-124" data-mp="1ipkwa8t1hifa">One Complete Teaching Kit.</Accent>
            </>} body="Everything you need to plan, demonstrate, correct and assess — from your first beginner class to advanced e-file training." data-id="element-123" data-mp="1noedocbg5tkq" />

        <img src={MOCKUP_URL} alt="The Nail Educator Ready kit — six core volumes and five bonuses" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[560px] object-contain lg:max-w-[820px]" style={{
        filter: 'drop-shadow(0 30px 36px rgba(120, 96, 56, 0.22))'
      }} data-id="element-125" data-mp="14pjzp5jt4x5m" />

        {/* 6 core volumes */}
        <div className="mt-14" data-id="element-126" data-mp="pwxk8w0fnca9">
          <div className="flex items-baseline justify-between gap-4 border-b border-brand-charcoal/15 pb-4" data-id="element-127" data-mp="ptt91eojvga3">
            <h3 className="font-display text-[1.9rem] font-bold leading-none text-brand-charcoal sm:text-[2.3rem]" data-id="element-128" data-mp="1djnkbrt80ws8">
              The 6 Core Volumes
            </h3>
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/55" data-id="element-129" data-mp="14k0kvbk1y11t">
              150 Lessons
            </p>
          </div>
          <ol className="grid gap-x-12 sm:grid-cols-2" data-id="element-130" data-mp="3parjchfu7hnu">
            {guides.map(guide => <li key={guide.number} className="flex items-start gap-4 border-b border-brand-charcoal/10 py-5" data-id="element-131" data-mp="3uanedr6k3yr9">
                <span aria-hidden="true" className="flex h-10 w-10 flex-none items-center justify-center rounded-full font-display text-[1.1rem] font-bold text-brand-charcoal" style={{
              backgroundColor: guide.accent
            }} data-id="element-132" data-mp="1zsubnj92coy1">
                  {Number(guide.number)}
                </span>
                <span data-id="element-133" data-mp="1m0o60r3je0cu">
                  <span className="block font-display text-[1.3rem] font-bold leading-snug text-brand-charcoal" data-id="element-134" data-mp="1h3xgld5udser">
                    {guide.title}
                  </span>
                  <span className="mt-1 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-135" data-mp="1c6nvg9phk2wq">
                    {guide.description}
                  </span>
                </span>
              </li>)}
          </ol>
        </div>

        {/* 5 extra bonuses */}
        <div className="mt-16" data-id="element-136" data-mp="31ig7yh2o4m3o">
          <div className="flex items-baseline justify-between gap-4 border-b border-brand-charcoal/15 pb-4" data-id="element-137" data-mp="2xhnwdh6bq548">
            <h3 className="flex items-center gap-3 font-display text-[1.9rem] font-bold leading-none text-brand-charcoal sm:text-[2.3rem]" data-id="element-138" data-mp="ja4spn8ru9a8">
              <GiftIcon className="h-6 w-6 text-brand-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-139" data-mp="o7oi9jax68hh" />
              Plus 5 Extra Bonuses
            </h3>
            <p className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-cta" data-id="element-140" data-mp="x11m3gaiuuic">
              Included Free
            </p>
          </div>

          <ol className="mt-8 grid gap-6 md:grid-cols-2" role="list" data-id="element-141" data-mp="cvdyjee5jzb">
            {bonusDetails.map((bonus, index) => <li key={bonus.number} className={`flex h-full flex-col overflow-hidden rounded-[20px] border border-brand-charcoal/10 bg-white shadow-[0_24px_50px_-36px_rgba(90,70,40,0.45)] ${index === bonusDetails.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-142" data-mp="9bp2dmhkj41s" data-mpi={index}>
                <div className="flex items-center justify-between px-6 py-3" style={{
              backgroundColor: bonus.accent
            }} data-id="element-143" data-mp="1pp5qzzl9r3jz">
                  <p className="font-body text-[11px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/80" data-id="element-144" data-mp="1o9bj8ue64wx6">
                    {bonus.number}
                  </p>
                  <p className="font-body text-[11px] font-bold uppercase tracking-[0.16em] text-brand-charcoal/80" data-id="element-145" data-mp="1x9q5px2vci29">
                    Free
                  </p>
                </div>
                <div className="flex flex-1 flex-col px-6 py-7 sm:px-8" data-id="element-146" data-mp="2774agzffjieq">
                  <h4 className="font-display text-[1.5rem] font-bold leading-snug text-brand-charcoal" data-id="element-147" data-mp="275b31hwzsu5o">
                    {bonus.title}
                  </h4>
                  <p className="mt-2 font-body text-[15px] font-semibold leading-snug text-brand-gold" data-id="element-148" data-mp="2gw5ssw9g6bvv">
                    {bonus.hook}
                  </p>
                  <p className="mt-2.5 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-149" data-mp="2pxvpohm3m311">{bonus.description}</p>
                  {bonus.flow && <p className="mt-auto pt-5 font-body text-[11px] font-semibold uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-150" data-mp="2l0vlkc8t7ack">
                      {bonus.flow}
                    </p>}
                </div>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}